import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

import useQuery from './useQuery'

// By default, return required consents only
export default function usePatientConsents(id, query, options = {}) {
  return useQuery({
    queryKey: QK.patients.id(id).consents.list(query),
    queryFn: () => API.patients.id(id).consents.list(query),
    ...options,
  })
}
